import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotTopics from './components/HotTopics';
import NewsGrid from './components/NewsGrid';

export default function Home() {
  return (
    <>
      <SEOHead />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <HotTopics />
        <NewsGrid />
      </main>

      <Footer />
    </>
  );
}